var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcHomeGray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#A0A0A0",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M14.85 6.646l-1.072-1-5.899-5.5c-.209-.195-.548-.195-.758 0l-5.898 5.5-1.072 1c-.206.2-.2.516.013.708.207.187.537.187.745 0l.156-.147V13.5c0 .276.24.5.536.5h11.797c.296 0 .536-.224.536-.5V7.207l.157.146c.213.192.553.187.758-.012.201-.194.201-.501 0-.695zM9.107 13H5.891V9h3.217v4zm3.754 0H10.18V8.5c0-.276-.24-.5-.536-.5h-4.29c-.296 0-.536.224-.536.5V13H2.138V6.207l5.362-5 5.362 5V13z",
    transform: "translate(-15 -210) translate(-1 205) translate(10) translate(6 5)"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcHomeGray);
export default __webpack_public_path__ + "static/media/ic_home_gray.d240cf0023083eb6c589b0225d740f7d.svg";
export { ForwardRef as ReactComponent };